module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "SiteContent"
  }, [_vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-61f15543"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SiteContent.vue
// module id = 774
// module chunks = 1474